import React from "react";
import { Skeleton } from "@mui/material";
import "./StatCardSkeleton.scss";

/**
 * Componente skeleton para StatCard durante estados de carga
 */
export const StatCardSkeleton = ({ className = "", ...props }) => {
  return (
    <div className={`stat-card-skeleton ${className}`} {...props}>
      <div className="stat-card-skeleton__icon-container">
        <Skeleton
          variant="circular"
          width="100%"
          height="100%"
          animation="wave"
        />
      </div>

      <Skeleton
        variant="text"
        className="stat-card-skeleton__title"
        animation="wave"
      />

      <Skeleton
        variant="text"
        className="stat-card-skeleton__count"
        animation="wave"
      />
    </div>
  );
};
